import React from 'react';

//dropdown DEPARTAMENTOS
const DetalleSelDe = props => {
  return (
    <option dato1={props.elemento.codigoDpto} value={props.elemento._id}>{props.elemento.descrDpto}</option>
  )
};

const ListaDe = ({styles, handleLista, list, codigoCiudadUA, codigoDptoUA, esUpd, argsDocum, idLista, permiteUpdate}) => {
  // console.log(esUpd, argsDocum, idLista, permiteUpdate)
  // console.log(list, codigoCiudadUA, codigoDptoUA)
  let listaDir = list
  if(codigoDptoUA!=="Todos..."){
    listaDir = listaDir.filter(elemento => elemento.codigoDpto===codigoDptoUA)
  }
// console.log(listaDir)
  const detalleDe = listaDir.map((elemento, _id) => <DetalleSelDe elemento={elemento} key={elemento._id} />);
  if(!esUpd){
    if(codigoDptoUA==="Todos..."){
      return(
        <div>
          <select style={styles.input}className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={handleLista}>
            <option value="">Todos...</option>
            {detalleDe}
          </select>
        </div>
      )
    }else{
      return(
        <div>
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={handleLista}>
            {detalleDe}
          </select>
        </div>
      )
    }
  }else{
    if(codigoDptoUA==="Todos..."){
      // console.log(permiteUpdate, argsDocum.descrDpto, idLista.descrDpto)
      return(
        <div>
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" value={permiteUpdate?argsDocum._idDpto:idLista._idDpto} onChange={(ev)=>handleLista(ev, argsDocum)}>
            <option value="">Todos...</option>
            {detalleDe}
          </select>
        </div>
      )
    }else{
      return(
        <div>
          <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" value={permiteUpdate?argsDocum._idDpto:idLista._idDpto} onChange={(ev)=>handleLista(ev, argsDocum)}>
            {detalleDe}
          </select>
        </div>
      )
    }
  }
};
//Fin dropdown DEPARTAMENTOS

export default ListaDe